import styles from './number-bullet.module.css';

export default function NumberedBullet({ stepNumber, className }) {
  return (
    <span className={`${styles.container} ${className ? className : ''}`}>
      {stepNumber}
    </span>
  );
}
